import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  process.env.REACT_APP_BASE_API_URL,
  process.env.REACT_APP_ANON_TOKEN
);
